module.exports = __webpack_public_path__ + "static/media/bunny_1.016a1def.jpg";